import type { ReactNode } from 'react';

import classNames from 'classnames';

import { Button, Disclosure, DisclosurePanel, Icon } from '@iconik-io/uad';

import styles from './filters_disclosure.module.css';

export type FiltersDisclosureProps = {
  children: ReactNode;
  /** Pins the trigger button to the top of its scroll container. */
  sticky?: boolean;
  triggerAriaLabel?: string;
  defaultExpanded?: boolean;
};

export function FiltersDisclosure({
  children,
  sticky,
  triggerAriaLabel = 'Disclose filters',
  defaultExpanded,
}: FiltersDisclosureProps) {
  return (
    <Disclosure
      defaultExpanded={defaultExpanded}
      className={classNames({ [styles.sticky]: sticky })}
    >
      <Button
        slot="trigger"
        variant="tertiary"
        aria-label={triggerAriaLabel}
        icon={<Icon name="filter" size="s" />}
        className={styles.disclosure_button}
        size="m"
      />
      <DisclosurePanel lazyMount position="right">
        {children}
      </DisclosurePanel>
    </Disclosure>
  );
}
